module.exports = __webpack_public_path__ + "static/media/Scrafty_gaussian2.037d1737.png";